import React from "react";
import { useNavigate } from "react-router";

import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";

import { useAppSelector } from "store/hooks";

import { routes } from "routes/routes";

const TrialSidebarBanner: React.FC = () => {
  const navigate = useNavigate();

  const showBanner = useAppSelector(
    (state) => state.subscription.showSidebarBanner
  );
  const daysLeft =
    useAppSelector(
      (state) => state.subscription.subscription?.subscriptionDurationDays
    ) || 0;
  const isTrial = useAppSelector(
    (state) => state.subscription.subscription?.isTrial
  );

  const progress = 100 - ((daysLeft > 0 ? daysLeft : 0) / 11) * 100;

  const renderDays = () => {
    const rest = daysLeft % 10;

    switch (rest) {
      case 1:
        return `${daysLeft} день`;
      case 2:
      case 3:
      case 4:
        return `${daysLeft} дні`;
      default:
        return `${daysLeft} днів`;
    }
  };

  const onChooseTariff = () => {
    navigate(routes.subscription);
  };

  return (
    showBanner && (
      <div className="trial-sidebar-banner">
        <Typography fontWeight="bold" sx={{ mb: 0.5 }}>
          Тарифи
        </Typography>
        <Typography variant="body2" color="grey700" sx={{ mb: 2 }}>
          {isTrial
            ? daysLeft > 0
              ? `Залишилось ${renderDays()} ознайомчого періоду.`
              : "Ознайомчий період завершився."
            : "Термін дії передплати закінчився."}
        </Typography>
        <LinearProgress
          sx={{ mb: 2 }}
          color="primary"
          variant="determinate"
          value={progress}
        />
        <Link
          color="primary.main"
          underline="none"
          component="button"
          onClick={onChooseTariff}
        >
          {isTrial ? "Обрати Тариф зараз" : "Оновити тариф"}
        </Link>
      </div>
    )
  );
};

export default TrialSidebarBanner;
